import { Phone, FileText, PenTool, Rocket } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  {
    n: "01",
    icon: Phone,
    title: "Échange gratuit",
    desc: "On parle de votre activité, de vos besoins et de vos objectifs. 15 minutes au téléphone suffisent.",
  },
  {
    n: "02",
    icon: FileText,
    title: "Devis & maquette",
    desc: "Vous recevez un devis ferme et un aperçu du design, avant tout engagement.",
  },
  {
    n: "03",
    icon: PenTool,
    title: "Création du site",
    desc: "Nous développons votre site avec vos contenus, vos photos et vos couleurs. Vous suivez l'avancement.",
  },
  {
    n: "04",
    icon: Rocket,
    title: "Mise en ligne & suivi",
    desc: "Votre site est publié, visible sur Google, et vous savez le faire vivre en toute autonomie.",
  },
];

export const Process = () => (
  <section id="methode" className="py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <Reveal>
          <Eyebrow>La méthode</Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-5 font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl">
            De l'appel à la mise en ligne, en 4 étapes.
          </h2>
        </Reveal>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.08} className="h-full">
            <div
              data-testid={`process-step-${i}`}
              className="group relative h-full rounded-3xl border border-navy/10 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-gold/40 hover:shadow-xl hover:shadow-gold/10"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-sm font-semibold text-gold-dark">{s.n}</span>
                <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-navy text-gold transition-transform duration-300 group-hover:scale-110">
                  <s.icon size={17} strokeWidth={2} />
                </span>
              </div>
              <h3 className="mt-6 font-display text-lg font-bold text-navy">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.desc}</p>
              {i < 3 && (
                <span className="absolute -right-3 top-1/2 hidden h-px w-6 bg-gold/40 lg:block" />
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
